import { observable } from 'mobx';
import { PayerOnboardingPage } from '../index';
import { FormField } from '../../../WebGiving/components/form-field';
import { ValidationState, validateFields } from '../../../WebGiving/validation/view-model-validator';
import { createRulesFromMetadata } from '../../../WebGiving/validation/validation-rules';
import { ModelMetadata } from '../../payer-onboarding-generated';
import { AchPaymentMethodViewModel } from '../page-payment-method/ach-payment-method-view-model';
import { PayerOnboardingPageViewModelBase } from '../payer-onboarding-page-view-model';

export class PageConfirmBankAccountViewModel extends PayerOnboardingPageViewModelBase {
	readonly type: PayerOnboardingPage = PayerOnboardingPage.ConfirmBankAccount;
	accountNumberConfirm: FormField<string>;

	@observable
	validationState?: ValidationState;

	validate(): ValidationState {
		return validateFields(this, 'Please enter valid details');
	}

	constructor(public achModel: AchPaymentMethodViewModel, public bankName: string) {
		super();
		this.accountNumberConfirm = new FormField<string>('', createRulesFromMetadata(ModelMetadata.ConfirmAchAccountRequest.AccountNumber));
	}
}
